
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 84 84"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.665 57.167c2.272.083 4.392.25 6.664.5 1.818.25 3.03 1.25 2.575 2.25-.303.75-1.363 1.25-2.575 1.416-2.272.25-4.392.417-6.664.5-2.272.084-4.393.167-6.665.167-2.272 0-4.393 0-6.665-.167a89.598 89.598 0 01-6.664-.5c-1.818-.25-3.03-1.25-2.575-2.25.151-.666 1.212-1.25 2.575-1.416a89.598 89.598 0 016.664-.5C37.607 57.083 39.728 57 42 57c2.272 0 4.393 0 6.665.167zM27.5 30a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm29 0a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM42 84c23.196 0 42-18.804 42-42S65.196 0 42 0 0 18.804 0 42s18.804 42 42 42z"}})])
          )
        }
      }
    